<div class="apply-one-grid apply-one-style">
  <ng-container *ngIf="contractsByBrand; then usageSelector else loader"></ng-container>
</div>

<!-- usage selector -->
<ng-template #usageSelector>
  <div class="site-width">
    <div class="container-fluid pt-1 pt-md-3 pb-2 pb-md-3">
      <h1>{{ 'ecm.selector.usage.title' | translate }}</h1>

      <!-- equipments list -->
      <ng-container *ngIf="contractsByBrand && contractsByBrand.size > 0; else noEquipmentAvailable">
        <div
          *ngFor="let brand of brandsAvailable; let isFirst = first; let isLast = last"
          [ngClass]="{'mb-2 mb-md-3': contractsByBrand.size > 1 && !isLast}"
        >
          <!-- other universe title, when multiple brand are available -->
          <h2 *ngIf="contractsByBrand.size > 1 && !isFirst" class="h3">
            {{ 'ecm.selector.universe.' + brand + '.title' | translate }}
          </h2>

          <ul class="items-list row">
            <ng-container *ngFor="let contract of contractsByBrand.get(brand)">
              <li *ngFor="let usage of contract.usages" class="col-12 col-md-6">
                <ecm-mat-item-list
                  [itemIcon]="isFirst ? itemsRender.get(contract.cid + '_' + usage.usageCode).icon : reverseBrandLogoUrl"
                  [itemLabel]="itemsRender.get(contract.cid + '_' + usage.usageCode).label"
                  [itemText]="itemsRender.get(contract.cid + '_' + usage.usageCode).description"
                  [itemPath]="getReturnUrl(contract.cid, usage.usageCode)"
                  [e2e]="contract.cid + '_' + usage.usageCode"
                  (materialItemListEvent)="redirectToReturnUrl(contract, usage.usageCode)"
                ></ecm-mat-item-list>
              </li>
            </ng-container>
          </ul>
        </div>
      </ng-container>

      <!-- no usage / contract available -->
      <ng-template #noEquipmentAvailable>
        <div class="text-mw">
          <ecm-mat-alert
            [style]="'warning'"
            [title]="'ecm.selector.error.unavailable.title' | translate"
          ></ecm-mat-alert>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- rebound links -->
  <ecm-selector-rebound-links *ngIf="!isWebviewContext" [universe]="universe"></ecm-selector-rebound-links>
</ng-template>

<!-- loader -->
<ng-template #loader>
  <div class="py-5">
    <ecm-mat-spinner></ecm-mat-spinner>
  </div>
</ng-template>
